import styled from "../../styled";
import { themeLss } from "../../lss";
import { media } from "../../theme";
/**
 * Base container that provides responsive padding
 */

export var Container = styled.main(function (_ref) {
  var theme = _ref.theme,
      isFluid = _ref.isFluid;
  return "\n  display: flex;\n  margin: 0 auto;\n  padding: 0 ".concat(theme.space.xl, ";\n  width: 100%;\n  height: 100%;\n  min-height: 100%;\n  flex-direction: column;\n  ").concat(media.tablet(theme), " {\n    padding-left: ").concat(theme.space.lg, ";\n    padding-right: ").concat(theme.space.lg, ";\n    max-width: ").concat(isFluid ? 'none' : "calc(".concat(theme.breakpoints.tablet, " - ").concat(theme.space.lg, " - ").concat(theme.space.lg, ")"), ";\n  }\n  ").concat(media.desktop(theme), " {\n    max-width: ").concat(isFluid ? 'none' : "calc(".concat(theme.breakpoints.desktop, " - ").concat(theme.space.xl, " - ").concat(theme.space.xl, ")"), "\n  }\n");
}, themeLss());